import _ from 'lodash';
import getErrors from '../../../../shared/lib/geterrors';
import AnagraficaService from '../../../../shared/services/api/anagrafica';

// Base anagrafica submit
export const onBaseSubmit = (
  values,
  { setSubmitting, setErrors, setValues },
  {
    anagraficaId,
    onEdit,
    update,
    submitRelated,
    notifications,
    setAnagraficaId,
    nextStep,
    tipoValidazione,
    initialValues,
  },
  addIntestatario
) => {
  setSubmitting(true);

  if (
    !_.isEmpty(values.indirizzi) &&
    !_.isEmpty(values.indirizzi[0]) &&
    _.isEmpty(values.indirizzi[0].indirizzoCompleto)
  ) {
    values.indirizzi = []; // eslint-disable-line no-param-reassign
  }

  const formattedRecapiti = [];
  values.recapiti.forEach((recapito) => {
    formattedRecapiti.push({
      ...recapito,
      nome: recapito.nome.trim(),
    });
  });

  // eslint-disable-next-line no-param-reassign
  values.recapiti = formattedRecapiti;

  const payload = {
    ...values,
    nome: values.nome.trim().toUpperCase(),
    cognome: values.cognome.trim().toUpperCase(),
    codicefiscale: values.codicefiscale ? values.codicefiscale.toUpperCase() : '',
    tipoValidazione: tipoValidazione.toLowerCase(),
    anagrafica: anagraficaId || '',
    cittadinanza: _.has(values, 'cittadinanza.value') ? values.cittadinanza.value : values.cittadinanza,
    statoCivile: _.has(values, 'statoCivile.value') ? values.statoCivile.value : values.statoCivile,
    dataNascita: values.dataNascita ? +values.dataNascita.format('X') : '',
    ruoli: values.ruoli ? values.ruoli.map((obj) => (obj.value ? obj.value : obj)) : [],
    provenienza: values.provenienza ? values.provenienza.value : '',
    collaboratore: _.has(values, 'collaboratore.value') ? values.collaboratore.value : values.collaboratore,
    sesso: _.has(values, 'sesso.value') ? values.sesso.value : values.sesso,
    dettaglioProvenienza: values.dettaglioProvenienza || null,
    provenienzaTecnocasa: _.has(values, 'provenienzaTecnocasa.value')
      ? values.provenienzaTecnocasa.value
      : values.provenienzaTecnocasa,
    privacy: {
      privacy: values['privacy.privacy'],
      consensoMarketing: values['privacy.marketing'],
      consensoProfilazione: values['privacy.profilazione'],
      consensoInvioEmail: values['privacy.consensoInvioEmail'],
    },
    indirizzi:
      values.domicilioDiversoDaResidenza === 'true'
        ? values.indirizzi
        : values.indirizzi.filter((indirizzo) => indirizzo.tipo !== 'domicilio'), // Se domicilio diverso da residenza false cancello domicilio
    debiti: values.debiti
      ? values.debiti.map((debito) => ({
          dataScadenza: +debito.scadenza.format('X'),
          importoRata: debito.importo,
          istituto: debito.istituto,
        }))
      : [],
    sessoTitolareEffettivo: _.has(values, 'sessoTitolareEffettivo.value')
      ? values.sessoTitolareEffettivo.value
      : values.sessoTitolareEffettivo,
    nomeTitolareEffettivo: values.nomeTitolareEffettivo.trim().toUpperCase(),
    cognomeTitolareEffettivo: values.cognomeTitolareEffettivo.trim().toUpperCase(),
    dataNascitaTitolareEffettivo: values.dataNascitaTitolareEffettivo
      ? +values.dataNascitaTitolareEffettivo.format('X')
      : '',
    cittaRegistroImprese: _.has(values, 'cittaRegistroImprese.value') 
      ? values.cittaRegistroImprese.value 
      : (values.cittaRegistroImprese || ''),
    numeroRegistroImprese: values.numeroRegistroImprese || '',
  };

  if (values.codiceL3) {
    payload.userAcl = {
      ...values.userAcl,
      username: values.codiceL3,
    };
  }

  if (payload.tipoValidazione === 'anagrafica' || payload.tipoValidazione === 'cliente') {
    payload.reddito = {
      id: values.reddito_id || '',
      anagrafica: anagraficaId || '',
      tipoValidazione: values.reddito_tipoValidazione,
      occupazione: _.has(values, 'reddito_occupazione.value')
        ? values.reddito_occupazione.value
        : values.reddito_occupazione,
      professione: _.has(values, 'reddito_professione.value')
        ? values.reddito_professione.value
        : values.reddito_professione,
      partitaivaDatorelavoro: values.reddito_partitaivaDatorelavoro,
      pecDatorelavoro: values.reddito_pecDatorelavoro,
      nomeDatorelavoro: values.reddito_nomeDatorelavoro,
      tfrMaturato: values.reddito_tfrMaturato,
      redditoMensileNetto: values.reddito_redditoMensileNetto,
      redditoAnnuoNetto: values.reddito_redditoAnnuoNetto,
      numeroMensilita: values.reddito_numeroMensilita,
      dataAssunzione: values.reddito_dataAssunzione ? +values.reddito_dataAssunzione.format('X') : '',
      numeroFamiliariCarico: values.reddito_numeroFamiliariCarico,
      tipologiaDatorelavoro: _.has(values, 'reddito_tipologiaDatorelavoro.value')
        ? values.reddito_tipologiaDatorelavoro.value
        : values.reddito_tipologiaDatorelavoro,
    };

    if (payload.collaboratore !== initialValues.collaboratore) {
      payload.invioEmailCambioCollaboratore = confirm('Inviare una notifica e-mail al collaboratore assegnato?'); // eslint-disable-line no-alert
    }
  }

  delete payload['privacy.privacy'];
  delete payload['privacy.profilazione'];
  delete payload['privacy.marketing'];
  delete payload['privacy.consensoInvioEmail'];
  delete payload.telefono;
  delete payload.email;
  delete payload._embedded;
  delete payload.reddito_id;
  delete payload.reddito_tipoValidazione;
  delete payload.reddito_occupazione;
  delete payload.reddito_professione;
  delete payload.reddito_codiceFiscaleDatorelavoro;
  delete payload.reddito_pecDatorelavoro;
  delete payload.reddito_tfrMaturato;
  delete payload.reddito_redditoMensileNetto;
  delete payload.reddito_numeroMensilita;
  delete payload.reddito_dataAssunzione;
  delete payload.reddito_numeroFamiliariCarico;
  delete payload.reddito_tipologiaDatorelavoro;
  delete payload.reddito_nomeDatorelavoro;
  delete payload.reddito_partitaivaDatorelavoro;
  delete payload.reddito_redditoAnnuoNetto;

  // New Anagrafica
  if (!values.id || values.id.length === 0) {
    // Save new anagrafica
    AnagraficaService.create(payload)
      .then(({ headers, data }) => {
        // Update form values if needed
        setValues({
          ...values,
          id: data.id,
          nominativo: data.nominativo,
          dettaglioCollaboratore: data.dettaglioCollaboratore,
          dettaglioCoordinatore: data.dettaglioCoordinatore,
          dettaglioInternoKiron: data.dettaglioInternoKiron,
          dettaglioResponsabileArea: data.dettaglioResponsabileArea,
        });

        // Update parent with new data and resend to formik
        onEdit(data);

        if (data.provenienzaIniziale !== payload.provenienza && data.toDelete === true) {
          // Success notification with warning related to provenienza
          notifications.addNotification({
            message: 'Anagrafica salvata. Codice fiscale già presente, mantenuta la provenienza originale',
            level: 'success',
          });
        } else {
          // Success notification
          notifications.addNotification({
            message: 'Anagrafica salvata',
            level: 'success',
          });
        }

        if (headers['invalid-mail']) {
          // Warning notification
          notifications.addNotification({
            message: 'L’INDIRIZZO MAIL POTREBBE ESSERE INESISTENTE',
            level: 'warning',
          });
        }

        // Update parent list
        update();

        // Add soggetto to pratica (anagrafica created from pratica)
        if (_.isFunction(addIntestatario)) {
          addIntestatario(data);
        }

        // Aggiungo id nuova anagrafica, mostro form successivo
        setAnagraficaId(data.id, nextStep);
        setSubmitting(false);

        // Save releated data
        submitRelated();
      })
      .catch((errors) => {
        const errorsObj = getErrors(errors);
        setSubmitting(false);
        setErrors(errorsObj);

        // Errors notification
        notifications.addNotification({
          message:
            _.get(errors, 'data.detail') && _.get(errors, 'data.detail') !== 'Failed Validation'
              ? errors.data.detail
              : 'Si è verificato un problema con il salvataggio del form, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  } else {
    // Anagrafica update
    AnagraficaService.put(payload)
      .then(({ headers, data }) => {
        // Update form values if needed
        setValues({
          ...values,
          id: data.id,
          nominativo: data.nominativo,
        });

        // Update parent with new data and resend to formik
        onEdit(data);

        // Success notification
        notifications.addNotification({
          message: 'Anagrafica aggiornata',
          level: 'success',
        });

        if (headers['invalid-mail']) {
          // Warning notification
          notifications.addNotification({
            message: 'L’INDIRIZZO MAIL POTREBBE ESSERE INESISTENTE',
            level: 'warning',
          });
        }

        // Update parent list
        update();

        // Add soggetto to pratica (anagrafica created from pratica)
        if (_.isFunction(addIntestatario)) {
          addIntestatario(data);
        }

        // mostro form successivo
        nextStep();
        setSubmitting(false);

        // Save releated data
        submitRelated();
      })
      .catch((errors) => {
        setSubmitting(false);
        setErrors(getErrors(errors));

        // Error notification
        notifications.addNotification({
          message:
            _.get(errors, 'data.detail') && _.get(errors, 'data.detail') !== 'Failed Validation'
              ? errors.data.detail
              : 'Si è verificato un problema con il salvataggio del form, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  }
};

export default onBaseSubmit;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Base/submit.js